import {
  faTrashCan,
  faClockRotateLeft,
} from "@fortawesome/pro-solid-svg-icons";
import { BatchActionPill } from "./BatchActionPill";

export default {
  title: "CatalogIndex/BatchActionPill",
  component: BatchActionPill,
};

export const Active = () => (
  <BatchActionPill
    selectedCount={3}
    actions={[{ icon: faTrashCan, label: "Archive", onClick: () => {} }]}
  />
);

export const ArchivedWithRestoreAndPurge = () => (
  <BatchActionPill
    selectedCount={2}
    actions={[
      { icon: faClockRotateLeft, label: "Restore", onClick: () => {} },
      {
        icon: faTrashCan,
        label: "Permanently delete",
        onClick: () => {},
        variant: "danger",
      },
    ]}
  />
);

export const ZeroSelected = () => (
  <BatchActionPill
    selectedCount={0}
    actions={[{ icon: faTrashCan, label: "Archive", onClick: () => {} }]}
  />
);
